import {
  Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges
} from '@angular/core';

import { IrisTokenParserService } from '@sondermind/iris/shared';

@Component({
  selector: 'iris-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  host: {
    role: 'progressbar',
    '[class.iris-progress-bar--track-color]': 'trackColorToken !== ""',
    '[class.iris-progress-bar--fill-color]': 'fillColorToken !== ""',
    'aria-valuemin': '0',
    'aria-valuemax': '100',
    '[attr.aria-valuenow]': 'percentToDisplay'
  },
  standalone: false
})
export class IrisProgressBarComponent implements OnInit, OnChanges {
  @Input() currentStep: number = 0;
  @Input() totalSteps: number = 0;
  @Input() percentComplete: number | null = null;
  @Input() isIndeterminateLoading: boolean = false;
  @Input() trackColorToken: string = '';
  @Input() fillColorToken: string = '';

  percentToDisplay: number = 0;
  fillWidthStyle: string = '';

  constructor(
    private element: ElementRef<HTMLElement>,
    private irisTokenParserService: IrisTokenParserService,
  ) {}

  ngOnInit(): void {
    this.irisTokenParserService.setColorFromToken(this.trackColorToken, 'track', this.element);
    this.irisTokenParserService.setColorFromToken(this.fillColorToken, 'fill', this.element);
    this.updateFillStyle();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentStep'] || changes['percentComplete']) {
      this.updateFillStyle();
    }
  }

  private updateFillStyle(): void {
    this.percentToDisplay = this.validatePercent(
      this.calculatePercentToDisplay()
    );

    this.fillWidthStyle = this.calculateFillWidthStyle();
  }

  private calculateFillWidthStyle(): string {
    return this.percentToDisplay < 5
      ? '16px' // custom minimum fill width
      : `${this.percentToDisplay}%`;
  }

  private calculatePercentToDisplay(): number {
    return this.percentComplete !== null
      ? this.percentComplete
      : Math.round((this.currentStep / this.totalSteps) * 100);
  }

  private validatePercent(percent: number): number {
    if (percent > 100 || percent < 0) {
      throw new RangeError('iris-progress-bar cannot display given percentage. Percentage must be >=0 and <=100.');
    }
    return percent;
  }
}
